export const statusMatching = (status) => {
  switch (status) {
    case "success":
      return { text: "Complete", bg: "#DCFCE7", color: "#174A2A" };

    case "pending":
      return { text: "Waiting", bg: "#FEF3C7", color: "#F27D00" };

    case "failed":
      return { text: "Error", bg: "#FEE2E2", color: "#C71818" };

    default:
      return { text: "Error", bg: "#FEE2E2", color: "#C71818" };
  }
};
